import { render, staticRenderFns } from "./AddNotifications.vue?vue&type=template&id=1d8bd5bc&scoped=true&"
import script from "./AddNotifications.vue?vue&type=script&lang=js&"
export * from "./AddNotifications.vue?vue&type=script&lang=js&"
import style0 from "./AddNotifications.vue?vue&type=style&index=0&id=1d8bd5bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8bd5bc",
  null
  
)

export default component.exports